import { render } from "./DocumentCardListBatch.vue?vue&type=template&id=1c2d115b"
import script from "./DocumentCardListBatch.vue?vue&type=script&lang=js"
export * from "./DocumentCardListBatch.vue?vue&type=script&lang=js"
script.render = render

export default script